<script setup lang="ts">
const onEnter = (element: HTMLElement) => {
  element.style.height = 'auto'

  const height = getComputedStyle(element).height

  element.style.position = null
  element.style.visibility = null
  element.style.height = 0

  // eslint-disable-next-line no-unused-expressions
  getComputedStyle(element).height

  requestAnimationFrame(() => {
    element.style.height = height
  })
}

const onAfterEnter = (element) => {
  element.style.height = 'auto'
}

const onLeave = (element) => {
  const height = getComputedStyle(element).height

  element.style.height = height

  // eslint-disable-next-line no-unused-expressions
  getComputedStyle(element).height

  requestAnimationFrame(() => {
    element.style.height = 0
  })
}
</script>

<template>
  <Transition
    name="panel"
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @leave="onLeave"
  >
    <slot />
  </Transition>
</template>

<style lang="scss">
.panel {
  &-enter-from {
    @apply h-0 opacity-0;
  }

  &-enter-active {
    @apply overflow-hidden;
    transition: height 300ms, opacity 500ms ease-in-out;
  }

  &-enter-to {
    @apply opacity-100;
  }

  &-leave-active {
    @apply overflow-hidden;
    transition: height 300ms, opacity 200ms ease-in-out;
  }

  &-leave-from {
    @apply opacity-100;
  }

  &-leave-to {
    @apply h-0 opacity-0;
  }
}
</style>
